import { render } from "./PersonProduct.vue?vue&type=template&id=383e5c42&scoped=true&ts=true"
import script from "./PersonProduct.vue?vue&type=script&lang=ts"
export * from "./PersonProduct.vue?vue&type=script&lang=ts"

import "./PersonProduct.vue?vue&type=style&index=0&id=383e5c42&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383e5c42"]])

export default __exports__